import { graphql } from 'graphql-schema';

export const UPDATE_PASSWORD_MUTATION = graphql(`
  mutation updatePassword($currentPassword: String!, $newPassword: String!) {
    updatePassword(currentPassword: $currentPassword, newPassword: $newPassword) {
      _id
    }
  }
`);

export const UPDATE_CURRENT_USER = graphql(`
  mutation UpdateCurrentUser($input: ActionsUserUpdateCurrentUserInput!) {
    updateCurrentUser(input: $input) {
      _id
      userByUserId {
        _id
        username
        email
        first_name
        last_name
        gender
        zip
        shirt_size
      }
    }
  }
`);

export const GET_CURRENT_USER = graphql(`
  query GetCurrentUser {
    currentUser {
      _id
      email
      gender
      zip
      shirt_size
      first_name
      last_name
      username
      profile_picture
    }
  }
`);

export const GET_CURRENT_USER_PRIVACY_PREFS = graphql(`
  query GetCurrentUserPrivacyPrefs {
    currentUser {
      _id
      privacy_preferences {
        share_email
        share_phone
      }
    }
  }
`);

export const UPDATE_PRIVACY_PREFERENCES = graphql(`
  mutation updatePrivacyPreferences($userId: uuid!, $share_email: Boolean, $share_phone: Boolean) {
    insert_user_privacy_preferences_one(
      object: { user: $userId, share_email: $share_email, share_phone: $share_phone }
      on_conflict: {
        constraint: user_privacy_preferences_user_unique
        update_columns: [share_email, share_phone]
      }
    ) {
      _id
      share_email
      share_phone
    }
  }
`);

export const UPLOAD_PROFILE_PICTURE = graphql(`
  mutation UploadProfilePicture($userId: uuid!, $picture: String!) {
    update_users_by_pk(pk_columns: { _id: $userId }, _set: { profile_picture: $picture }) {
      _id
      profile_picture
    }
  }
`);

export const DEACTIVATE_CURRENT_USER = graphql(`
  mutation DeactivateCurrentUser($password: String!, $reason: String!) {
    deactivateCurrentUser(password: $password, reason: $reason) {
      _id
    }
  }
`);
